/**
 * Created by Mikhail Menshenin on 06.02.2026
 */

if (["playrix", "empire", "simple"].includes(cleverapps.config.ui)) {
    LevelMasteryWindow = Prefab.createWindow("levelmastery_window", "levelmastery_window_prefab_json");
}
